import type { HTMLAttributes, ReactNode } from 'react'
import { PageHeader } from '../PageHeader'
import { cn } from '../cn'
import { recipeDataAttrs } from './markers'

export type PageFrameProps = {
  title: ReactNode
  /** Heading level for the page title. Defaults to h1; use h2 when the route hero owns the page h1. */
  titleAs?: 1 | 2
  /** Optional harvest-stable name for the title heading (data-exact-set-name). */
  titleExactName?: string
  subtitle?: ReactNode
  actions?: ReactNode
  children?: ReactNode
  className?: string
  eyebrow?: ReactNode
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

/**
 * Page-1 — page chrome: PageHeader (default h1) + body region with recipe marker.
 * Extra DOM attrs (e.g. data-vjal-action from actionProps) land on the root.
 */
export function PageFrame({
  title,
  titleAs = 1,
  titleExactName,
  subtitle,
  actions,
  children,
  className = '',
  eyebrow,
  ...rest
}: PageFrameProps) {
  return (
    <div {...recipeDataAttrs('Page-1')} className={cn('flex min-w-0 max-w-full flex-col gap-6', className)} {...rest}>
      <PageHeader as={titleAs === 1 ? 'h1' : 'h2'} title={title} titleExactName={titleExactName} subtitle={subtitle} actions={actions} eyebrow={eyebrow} />
      <div className="min-w-0 max-w-full" data-vjal-page-body>{children}</div>
    </div>
  )
}
